/*
 * @flow strict
 * Copyright (C) 2019 MetaBrainz Foundation
 *
 * This file is part of MusicBrainz, the open internet music database,
 * and is licensed under the GPL version 2, or (at your option) any
 * later version: http://www.gnu.org/licenses/gpl-2.0.txt
 */

import {SidebarProperty}
  from '../../../../layout/components/sidebar/SidebarProperties.js';
import {bracketedText} from '../utility/bracketed.js';
import {kebabCase} from '../utility/strings.js';

import CollapsibleList from './CollapsibleList.js';

const buildAttributeListRow = (attribute: WorkAttributeT) => (
  <li
    className={'work-attribute work-attribute-' +
      kebabCase(attribute.typeName)}
    key={attribute.id}
  >
    {attribute.value_id == null
      ? attribute.value
      : lp_attributes(
        attribute.value, 'work_attribute_type_allowed_value',
      )}
    {' '}
    {bracketedText(lp_attributes(
      attribute.typeName,
      'work_attribute_type',
    ))}
  </li>
);

const buildAttributeSidebarRow = (attribute: WorkAttributeT) => (
  <SidebarProperty
    className={'work-attribute work-attribute-' +
      kebabCase(attribute.typeName)}
    key={attribute.id}
    label={addColonText(
      lp_attributes(attribute.typeName, 'work_attribute_type'),
    )}
  >
    {attribute.value_id == null
      ? attribute.value
      : lp_attributes(
        attribute.value, 'work_attribute_type_allowed_value',
      )}
  </SidebarProperty>
);

component AttributeList(
  attributes: ?ReadonlyArray<WorkAttributeT>,
  isSidebar: boolean = false,
) {
  return (
    <CollapsibleList
      ariaLabel={l('Work attributes')}
      buildRow={isSidebar ? buildAttributeSidebarRow : buildAttributeListRow}
      className={isSidebar ? 'properties work-attributes' : 'work-attributes'}
      ContainerElement={isSidebar ? 'dl' : 'ul'}
      InnerElement={isSidebar ? 'p' : 'li'}
      rows={attributes}
      showAllTitle={l('Show all attributes')}
      showLessTitle={l('Show less attributes')}
      toShowAfter={1}
      toShowBefore={2}
    />
  );
}

export default hydrate<React.PropsOf<AttributeList>>(
  'div.entity-attributes-container',
  AttributeList,
) as component(...React.PropsOf<AttributeList>);
